import React from 'react';
import Container from 'components/Container';

import iconStar from './images/icon-star.png';
import iconTerrace from './images/icon-wine.png';
import iconWalk from './images/icon-location.png';
import iconDiscount from './images/icon-dollar.png';
import { Perks as S } from './styles';

const features = [
  {
    title: '5-Star Rating',
    icon: iconStar,
  },
  {
    title: 'Panoramic Rooftop Pool & Bars',
    icon: iconTerrace,
  },
  {
    title: 'Stay at SWC Venue',
    icon: iconWalk,
  },
  {
    title: 'SWC Attendee Discount Price',
    icon: iconDiscount,
  },
];

class Perks extends React.Component {
  renderFeature = (feature) => {
    return (
      <S.Item
        key={feature.title}
        style={feature.style}
      >
        <img src={feature.icon} alt={feature.title} />
        <div>{feature.title}</div>
      </S.Item>
    );
  }
  render() {
    return (
      <S.Wrapper>
        <Container>
          { features.map((feature) => (
            this.renderFeature(feature)
          )) }
        </Container>
      </S.Wrapper>
    );
  }
}

export default Perks;



// WEBPACK FOOTER //
// ./src/containers/Hotel/Perks.js